import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
     component: () => import('./views/CaptionJoinrealtime.vue')
    },
    {
      path: '/emme',
      name: 'emme',
     component: () => import('./views/emme.vue')
    },
    {
      path: '/credits',
      name: 'credits',
      component: () => import('./views/Credits.vue')
    },
    {
      path: '/host',
      name: 'host',
      component: () => import('./views/CaptionHost.vue')
    },
    {
      path: '/join/:sessionname?',
      name: 'join',
      component: () => import('./views/CaptionJoin.vue'),
      props: true
      },
      {
        path: '/en',
        name: 'en',
        component: () => import('./views/en.vue'),
        props: true
      },
      {
        path: '/fix',
        name: 'fix',
        component: () => import('./views/CaptionJoin.vue'),
        props: true
      },
      {
          path: '/de',
          name: 'de',
          component: () => import('./views/de.vue'),
          props: true
      }
  ]
})
